import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { LoginComponent } from "./login.component";

const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        canLoad: [AuthGuard],
    }
]
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class LoginRoutingModule {}